import { EMPTY_STRING } from '../constants';
function flatten(pathNodes) {
    return pathNodes.reduce(function (acc, val) { return acc.concat(val); }, []);
}
export function getPathProps(path) {
    var _a;
    var pathProps = {
        element_path_names: [],
        element_path_pos: [],
        element_path_ids: [],
        element_path_uris: [],
        element_path_reasons: []
    };
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var pathNode = path_1[_i];
        pathProps.element_path_names.push(pathNode.name);
        pathProps.element_path_pos.push(((_a = pathNode.position) === null || _a === void 0 ? void 0 : _a.toString()) || EMPTY_STRING);
        pathProps.element_path_ids.push(pathNode.identifier || EMPTY_STRING);
        pathProps.element_path_uris.push(pathNode.uri || EMPTY_STRING);
        pathProps.element_path_reasons.push(pathNode.reason || EMPTY_STRING);
    }
    return pathProps;
}
export function getParentPath(parentAbsoluteLocation) {
    return parentAbsoluteLocation
        ? flatten(parentAbsoluteLocation.locations.map(function (location) { return location.pathNodes; }))
        : [];
}
export function getParentSpecVersions(parentAbsoluteLocation) {
    return parentAbsoluteLocation
        ? flatten(parentAbsoluteLocation.locations.map(function (location) { return location.specVersion; }))
        : [];
}
export function getParentSpecModes(parentAbsoluteLocation) {
    return parentAbsoluteLocation
        ? flatten(parentAbsoluteLocation.locations.map(function (location) { return location.specMode; }))
        : [];
}
//# sourceMappingURL=EventUtils.js.map